import { logger } from "@/utils/logger"
import { TrackEvent } from "./trackEvent.interface"

export const trackEvent: TrackEvent = (eventName, params = {}) => {
  logger.debug("[Action:Started] Dispatch event", eventName, params)
  window.gtag("event", eventName, params)
}
